module.exports = __webpack_public_path__ + "static/website-feature-2d91b341f7e2da93df79941ea2e2cc4b.gif";